
import actions from './actions'
export default {
  editarNovoSite: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickLink,
    label: 'Editar novo site'
  },
  opcoesDoSite: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickDropdown,
    label: 'Opções do site'
  },
  acessarSite: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickLink,
    label: 'Acessar site'
  },
  buscarSite: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickInput,
    label: 'Buscar site'
  },
  comoTransferirMeuSite: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickLink,
    label: 'Como transferir meu site'
  },
  alterarDominio: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickLink,
    label: 'Alterar domínio'
  },
  abrirFecharAccordionTransferencia: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickIcon,
    label: 'Abrir/fechar accordion transferência'
  },
  vejaComoConfigurarDominio: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickLink,
    label: 'Veja como configurar domínio'
  },
  abrirFecharAccordionDominioAguardandoConfiguracao: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickIcon,
    label: 'Abrir/fechar accordion domínio aguardando configuração'
  },
  abrirModalSsl: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickButton,
    label: 'Abrir modal SSL'
  },
  fecharAccordionDominioAguardandoConfiguracao: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickButton,
    label: 'Fechar accordion domínio aguardando configuração'
  },
  abrirAccordionAtivarSsl: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickIcon,
    label: 'Abrir accordion ativar SSL'
  },
  fecharAccordionAtivarSsl: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickIcon,
    label: 'Fechar accordion ativar SSL'
  },
  abrirFecharAccordionAtivandoSsl: {
    página: 'Lista de sites',
    category: 'Lista de sites',
    action: actions.clickIcon,
    label: 'Abrir/fechar accordion Ativando SSL'
  }
}
